import Vue from 'vue'
import VueRouter from 'vue-router'
import Adm from '@/components/Adm.vue'
import Order from '@/components/adm/Order.vue'
import User from '@/components/User.vue'
import ControlPanel from '@/components/user/ControlPanel.vue'
import Register from '@/components/user/Register.vue'
import Finance from '@/components/adm/Finance.vue'
import FinanceAdd from '@/components/adm/FinanceAdd.vue'
import Agreement from '@/components/user/Agreement.vue'
import PasswordForgot from '@/components/user/PasswordForgot.vue'
import PasswordRestore from '@/components/user/PasswordRestore.vue'
import Index from '@/components/user/Index.vue'
import Statistics from '@/components/user/Statistics.vue'
import Profile from '@/components/user/Profile.vue'
import History from '@/components/user/History.vue'
import UserOrder from '@/components/user/Order.vue'
import XvOrders from '@/components/adm/XvOrders.vue'
import Messages from '@/components/user/Messages.vue'
import ToCheck from '@/components/user/ToCheck.vue'
import Main from '@/components/adm/Main.vue'
import FinanceBase from '@/components/adm/FinanceBase.vue'
import OrderBase from '@/components/adm/OrderBase.vue'
import OrderEdit from '@/components/adm/OrderEdit.vue'
import PayAll from '@/components/adm/PayAll.vue'
import ListUserMessages from '@/components/adm/ListUserMessages.vue'
import XvOrdersHistory from '@/components/adm/XvOrdersHistory.vue'
import XvostovBase from '@/components/adm/XvostovBase.vue'
import XvOrderEdit from '@/components/adm/XvOrderEdit.vue'
import Users from '@/components/adm/Users.vue'
import XvOrderDone from '@/components/adm/XvOrderDone.vue'
import OrderHistory from '@/components/adm/OrderHistory.vue'
import XvUserOrders from '@/components/adm/XvUserOrders.vue'
import UserBase from '@/components/adm/UserBase.vue'
import UserEdit from '@/components/adm/UserEdit.vue'
import Auth from '@/components/adm/Auth.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/adm',
    component: Adm,
    children: [
      {
        path: 'order',
        component: OrderBase,
        children: [
          { path: 'add', component: Order },
          { path: 'edit/:id', component: OrderEdit, props: true },
          { path: 'history', component: OrderHistory }
        ]
      },
      {
        path: 'finance',
        component: FinanceBase,
        children: [
          { path: '', component: Finance },
          { path: 'add', component: FinanceAdd },
          { path: 'pay/all/:id', component: PayAll, props: true }
        ]
      },
      {
        path: 'xvostov',
        component: XvostovBase,
        children: [
          { path: '', component: XvOrders },
          { path: 'history', component: XvOrdersHistory },
          { path: 'order/edit/:id', component: XvOrderEdit, props: true },
          { path: 'order/done/:id', component: XvOrderDone, props: true },
          { path: 'orders/user/:userID', component: XvUserOrders, props: true }
        ]
      },
      { path: '', component: Main },
      { path: 'index.html', component: Main },
      {
        path: 'user',
        component: UserBase,
        children: [
          { path: 'messages/:id', component: ListUserMessages, props: true },
          { path: 'list', component: Users },
          { path: 'edit/:id', component: UserEdit, props: true }
        ]
      },
      { path: 'auth', component: Auth }
    ]
  },
  {
    path: '/',
    component: User,
    children: [
      { path: '', component: Index },
      { path: 'controlPanel.html', component: ControlPanel },
      { path: 'register.html', component: Register },
      { path: 'agreement', component: Agreement },
      { path: 'password/forgot', component: PasswordForgot },
      { path: 'password/restore', component: PasswordRestore },
      { path: 'statistics', component: Statistics },
      { path: 'profile', component: Profile },
      { path: 'history', component: History },
      { path: 'order/view/:id', component: UserOrder, props: true },
      { path: 'messages', component: Messages },
      { path: 'order/check/:id', component: ToCheck, props: true }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
